import { render, staticRenderFns } from "./benefits.vue?vue&type=template&id=56bbdd66&scoped=true&lang=pug&"
import script from "./benefits.vue?vue&type=script&lang=js&"
export * from "./benefits.vue?vue&type=script&lang=js&"
import style0 from "./benefits.vue?vue&type=style&index=0&id=56bbdd66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbdd66",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/insurance?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230927162708%2Fcomponents%2Fproducts%2Finsurance%2Fbenefits.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports